"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tradeHistoryBeet = exports.TradeHistory = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const tradeHistoryDiscriminator = [190, 117, 218, 114, 66, 112, 56, 41];
class TradeHistory {
    constructor(market, wallet, alreadyBought) {
        this.market = market;
        this.wallet = wallet;
        this.alreadyBought = alreadyBought;
    }
    static fromArgs(args) {
        return new TradeHistory(args.market, args.wallet, args.alreadyBought);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return TradeHistory.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address) {
        const accountInfo = await connection.getAccountInfo(address);
        if (accountInfo == null) {
            throw new Error(`Unable to find TradeHistory account at ${address}`);
        }
        return TradeHistory.fromAccountInfo(accountInfo, 0)[0];
    }
    static deserialize(buf, offset = 0) {
        return exports.tradeHistoryBeet.deserialize(buf, offset);
    }
    serialize() {
        return exports.tradeHistoryBeet.serialize({
            accountDiscriminator: tradeHistoryDiscriminator,
            ...this,
        });
    }
    static get byteSize() {
        return exports.tradeHistoryBeet.byteSize;
    }
    static async getMinimumBalanceForRentExemption(connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(TradeHistory.byteSize, commitment);
    }
    static hasCorrectByteSize(buf, offset = 0) {
        return buf.byteLength - offset === TradeHistory.byteSize;
    }
    pretty() {
        return {
            market: this.market.toBase58(),
            wallet: this.wallet.toBase58(),
            alreadyBought: this.alreadyBought,
        };
    }
}
exports.TradeHistory = TradeHistory;
exports.tradeHistoryBeet = new beet.BeetStruct([
    ['accountDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['market', beetSolana.publicKey],
    ['wallet', beetSolana.publicKey],
    ['alreadyBought', beet.u64],
], TradeHistory.fromArgs, 'TradeHistory');
//# sourceMappingURL=TradeHistory.js.map